import { render, staticRenderFns } from "./AddPostPage.vue?vue&type=template&id=3113f2fa&"
import script from "./AddPostPage.vue?vue&type=script&lang=js&"
export * from "./AddPostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports